export const localStorageEnalbed = () => {
  let storage: Storage;
  try {
    storage = (window as any)["localStorage"];
    const x = "__storage_test__";
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (_) {
    return false;
  }
};
